export default __webpack_public_path__ + "static/media/icons-20.57b3e708.ttf";